import React, { ChangeEvent } from "react";
import { useController } from "react-hook-form";

import styles from "./FormDate.module.css";

interface FormDateProps {
  id: string;
  placeholder?: string;
  label?: string;
  required?: boolean;
  type: "date" | "month";
}

const FormDate: React.FC<FormDateProps> = ({
  id,
  placeholder = "Placeholder",
  label = "label",
  required = false,
  type = "date",
}) => {
  const {
    field: { onChange: inputChanged, value },
  } = useController({ name: id });

  return (
    <div className={styles.formDateContainer}>
      <div className={required ? "requiredLabel" : ""}>{label}</div>
      <input
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          inputChanged(e.target.value)
        }
      />
    </div>
  );
};

export default FormDate;
